import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const WindowTintingPage = lazy(() => import('../pages/window-tinting/page'));
const MobileTintingPage = lazy(() => import('../pages/mobile-tinting/page'));
const CommercialTintingPage = lazy(() => import('../pages/commercial-tinting/page'));
const VehicleDecalsPage = lazy(() => import('../pages/vehicle-decals/page'));
const HeadlightTaillightPage = lazy(() => import('../pages/headlight-taillight-tinting/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Location Pages
const BaltimorePage = lazy(() => import('../pages/locations/baltimore/page'));
const OwingsMillsPage = lazy(() => import('../pages/locations/owings-mills/page'));
const ColumbiaPage = lazy(() => import('../pages/locations/columbia/page'));
const EllicottCityPage = lazy(() => import('../pages/locations/ellicott-city/page'));
const GlenBurniePage = lazy(() => import('../pages/locations/glen-burnie/page'));
const TowsonPage = lazy(() => import('../pages/locations/towson/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/window-tinting',
    element: <WindowTintingPage />,
  },
  {
    path: '/mobile-tinting',
    element: <MobileTintingPage />,
  },
  {
    path: '/commercial-tinting',
    element: <CommercialTintingPage />,
  },
  {
    path: '/vehicle-decals',
    element: <VehicleDecalsPage />,
  },
  {
    path: '/headlight-taillight-tinting',
    element: <HeadlightTaillightPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/locations/baltimore',
    element: <BaltimorePage />,
  },
  {
    path: '/locations/owings-mills',
    element: <OwingsMillsPage />,
  },
  {
    path: '/locations/columbia',
    element: <ColumbiaPage />,
  },
  {
    path: '/locations/ellicott-city',
    element: <EllicottCityPage />,
  },
  {
    path: '/locations/glen-burnie',
    element: <GlenBurniePage />,
  },
  {
    path: '/locations/towson',
    element: <TowsonPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
